// @ts-nocheck comment
import {Injectable} from '@angular/core';
import {BotatoChatStorageService} from '../../libs/botato-angular-lib/service/botato-chat-storage.service';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService extends BotatoChatStorageService {
    public setItem(key: string, value: string): Promise<void> {
        localStorage.setItem(key, value);
        return Promise.resolve();
    }

    public getItem(key: string): Promise<string> {
        return Promise.resolve(localStorage.getItem(key));
    }
}

